import { Modal } from "react-bootstrap";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import withPermission from "../../../core/common/autorisations/withPermission";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Spin } from "antd";
import { generatePaymentRecu } from "../../../api/studentPaiement";
//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const PaymentRecuModalApercu = ({ show, metaData, onClose }: Props) => {
  //   const { selectedYear } = useAcademicYear();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);

  // Fontion pour générer le recu de paiement
  const generatePaiementRecu = async () => {
    setIsLoading(true);
    try {
      // console.log("MetaData: ", metaData)
      const payload = { id: metaData?.id };
      const response = await generatePaymentRecu(payload);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      // console.log("relevé généré: ", response);
      toast.success("Fiche généré avec succès");
    } catch (error: any) {
      // console.log("erreur génération fiche: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false); // ← Toujours arrêter le chargement à la fin
    }
  };

  useEffect(() => {
    if (show) {
      generatePaiementRecu();
    } else {
      setPdfBlobUrl(null);
    }
  }, [show, metaData]);

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Recu de Paiement</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {!pdfBlobUrl && isLoading ? (
              <Spin
                indicator={
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              />
            ) : (
              <iframe
                src={pdfBlobUrl || ""}
                style={{ width: "100%", height: "100%" }}
                title="Aperçu PDF"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  PaymentRecuModalApercu,
  [
    buildPermission(Resource.PAYMENT, Action.READ),
    buildPermission(Resource.PAYMENT, Action.CREATE),
    buildPermission(Resource.PAYMENT, Action.UPDATE),
    buildPermission(Resource.PAYMENT, Action.DELETE),
  ],
  "masquer",
);
